namespace MWY {
    export interface ServiceError {
        Code?: string;
        Arguments?: string;
        Message?: string;
    }
}